// Values are veeAssistant.capability.* i18n keys, so chips can never drift from the catalogue
// phrases and every chip resolves to a shipped tool.
const CAPABILITY = (tool: string): string => `veeAssistant.capability.${tool}`

const FOLLOW_UPS_BY_TOOL: Record<string, string[]> = {
  get_my_balance: [CAPABILITY('get_leave_suggestions'), CAPABILITY('get_my_leaves')],
  get_my_leaves: [CAPABILITY('edit_leave'), CAPABILITY('cancel_leave')],
  get_leave_types: [CAPABILITY('get_my_balance'), CAPABILITY('get_leave_policy')],
  get_leave_policy: [CAPABILITY('get_my_balance'), CAPABILITY('get_leave_types')],
  get_team_leaves: [CAPABILITY('check_conflicts'), CAPABILITY('get_my_balance')],
  check_conflicts: [CAPABILITY('request_leave'), CAPABILITY('get_leave_suggestions')],
  search_knowledge_base: [CAPABILITY('get_leave_policy'), CAPABILITY('get_leave_types')],
  get_energy_score: [CAPABILITY('get_leave_suggestions')],
  get_leave_suggestions: [CAPABILITY('request_leave'), CAPABILITY('check_conflicts')],
  edit_leave: [CAPABILITY('get_my_leaves')],
  cancel_leave: [CAPABILITY('get_my_leaves'), CAPABILITY('get_my_balance')],
  request_leave: [],
}

const DEFAULT_FOLLOW_UPS = [CAPABILITY('get_my_balance'), CAPABILITY('get_team_leaves')]

export function getFollowUpKeys(toolNames: string[]): string[] {
  if (toolNames.length === 0) {
    return DEFAULT_FOLLOW_UPS
  }
  const keys = toolNames.flatMap((toolName) => FOLLOW_UPS_BY_TOOL[toolName] ?? [])
  return [...new Set(keys)].slice(0, 3)
}
